import { notification } from "antd";
import { cartwhite } from "assets/icons/index";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "redux/store";
import { RootState } from "redux/rootReducer";
import { userAddCartItemsActions } from "redux/actions/Cart/userAddCartItemsActions";
import { userGetCartItemsActions } from "redux/actions/Cart/userGetCartItemsActions";

interface FemaleCardProps {
  data?: any;
}

const FemaleCard = ({ data }: FemaleCardProps) => {
  const loginData = store?.getState()?.loginReducer?.loginData;
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { userId } = useSelector((state: RootState) => state.loginReducer);

  const { t, i18n } = useTranslation();
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="900"
      className="w-full h-full flex flex-col xl:flex-row items-center  gap-5"
    >
      {/* image section */}
      <div className="relative">
        <img src="images/femalepersonbg.jpg" alt="" />
        <p
          className={`absolute top-[35%] right-[15%] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[20px] text-second_color`}
        >
          {i18n.language === "en"
            ? data?.first_name_en.split("")
            : data?.first_name_ar.split("")}
        </p>
      </div>

      {/* inputs section  */}
      <div className="flex flex-col gap-2">
        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[400] text-[14px] text-[#444444] `}
        >
          {data?.age} {t("Years")} •{" "}
          {i18n.language === "en" ? data?.nationality_en : data?.nationality_ar}{" "}
          •{" "}
          {i18n.language === "en"
            ? data?.education_level_en
            : data?.education_level_ar}
        </p>

        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-first_color text-[14px] line-clamp-1 text-ellipsis`}
        >
          {i18n.language === "en" ? data?.description_en : data?.description_ar}
        </p>
        <div className="flex items-center gap-5">
          {/* monthly  */}
          <div
            onClick={() => {
              if (!loginData) {
                notification.warning({
                  message: `${t("You Need to login first")}`,
                });
                setTimeout(() => {
                  navigate("/login");
                }, 2000);
              } else {
                dispatch(
                  userAddCartItemsActions(
                    i18n.language,
                    userId,
                    {
                      user_id: userId,
                      device: "web",
                      project_type: "orphan",
                      id: data?.id,
                      duration: 1,
                      amount: 0,
                    },
                    () => {
                      dispatch(userGetCartItemsActions(userId, i18n.language));
                    }
                  )
                );
              }
            }}
            className={`w-[116px] h-[40px] bg-first_color rounded-[15px] text-white font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-[15px] flex items-center justify-center gap-2 hover:bg-[#614629] duration-300 cursor-pointer`}
          >
            <img src={cartwhite} alt="" /> {t("Monthly")}
          </div>

          {/* yearly */}
          <div
            onClick={() => {
              if (!loginData) {
                notification.warning({
                  message: `${t("You Need to login first")}`,
                });
                setTimeout(() => {
                  navigate("/login");
                }, 2000);
              } else {
                dispatch(
                  userAddCartItemsActions(
                    i18n.language,
                    userId,
                    {
                      user_id: userId,
                      device: "web",
                      project_type: "orphan",
                      id: data?.id,
                      duration: 12,
                      amount: 0,
                    },
                    () => {
                      dispatch(userGetCartItemsActions(userId, i18n.language));
                    }
                  )
                );
              }
            }}
            className={`w-[116px] h-[40px] bg-first_color rounded-[15px] text-white font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-[15px] flex items-center justify-center gap-2 hover:bg-[#614629] duration-300 cursor-pointer`}
          >
            <img src={cartwhite} alt="" /> {t("Yearly")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FemaleCard;
